module.exports = __webpack_public_path__ + "static/img/api_02.9347db3c.svg";